export function formatUnit(val) {
  if (val === undefined || val === null) return '0';

  if (Math.abs(val) >= 1_000_000) {
    return Math.round(val / 1_000_000) + 'M';
  } else if (Math.abs(val) >= 1_000) {
    return Math.round(val / 1_000) + 'K';
  } else {
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}

export function formatNumber(val) {
  if (val) {
    let tmp = val.toString().split('.');
    if (tmp.length === 1) {
      return tmp[0].replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    } else if (tmp.length === 2) {
      val = val.toFixed(1);
      tmp = val.toString().split('.');
      return tmp[0].replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") + '.' + tmp[1];
    }
  } else {
    return '-'
  }
}

export function formatDecimal(val, fixed=1) {
  if (val) {
    val = val.toFixed(fixed);
    if (fixed === 0) {
      return val.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }
    const tmp = val.toString().split('.');
    return tmp[0].replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") + '.' + tmp[1];
  } else {
    return '-'
  }
}

export function formatDecimalPlus(val, fixed=2) {
  if (val) {
    const dec = val.toFixed(fixed);
    if (dec > 0) {
      return '+' + dec;
    } else if (dec < 0) {
      return dec;
    }
  }
  return '-';
}

export function formatFixed(val, fixed=1) {
  if (val) {
    return val.toFixed(fixed)
  }
  return '-';
}

export function formatDate(val) {
  if (val) {
    if (val.length >= 8) {
      return val.substr(0,4) + '.' + val.substr(4,2) + '.' + val.substr(6,2);
    } else if (val.length >= 6) {
      return val.substr(0,2) + '.' + val.substr(2,2) + '.' + val.substr(4,2);
    } else if (val.length >= 4) {
      return val.substr(0,2) + '.' + val.substr(2,2);
    }
  }

  return val;
}

export function formatDate2(val) {
  if (val) {
    if (val.length >= 8) {
      return val.substr(0,4) + '년 ' + val.substr(4,2) + '월 ' + val.substr(6,2) + '일';
    } else if (val.length >= 6) {
      return val.substr(0,2) + '년 ' + val.substr(2,2) + '월 ' + val.substr(4,2) + '일';
    } else if (val.length >= 4) {
      return val.substr(0,2) + '월 ' + val.substr(2,2);
    }
  }

  return val;
}

export function formatDate3(val) {
  if (val) {
    if (val.length >= 8) {
      return val.substr(0,4) + '. ' + val.substr(4,2) + '. ' + val.substr(6,2) + '.';
    } else if (val.length >= 6) {
      return val.substr(0,2) + '. ' + val.substr(2,2) + '. ' + val.substr(4,2) + '.';
    } else if (val.length >= 4) {
      return val.substr(0,2) + '. ' + val.substr(2,2) + '.';
    }
  }

  return val;
}

export function formatDateStrg(val) {
  if (val && val.length > 5) {
    return Number(val.substr(4,2)) + '월';
  }
  return val;
}

export function formatMktTyp(val) {
  if (val === 1) {
    return 'KOSPI'
  } else if (val === 2) {
    return 'KOSDAQ'
  }
  
  return val;
}

export function getToday(format='YYYYMMDD') {
  let today=new Date();
  var year = today.getFullYear();
  var month = ('0' + (today.getMonth() + 1)).slice(-2);
  var day = ('0' + today.getDate()).slice(-2);

  if (format === 'YYMMDD') {
    return year.substring(2,4) + month + day;
  } else if (format === 'MMDD') {
    return month + day;
  }

  return year + month + day;

}

export function formatInvestor(val) {
  if (val) {
    const abs_val = Math.abs(val);
    if (abs_val > 100000000) {
      val =  parseInt(val / 100000000);
      if (val > 0) {
        return '+' + formatNumber(val) + '억원'
      } else {
        return formatNumber(val) + '억원'
      }
    } else if (abs_val > 10000) {
      val = parseInt(val / 10000);
      if (val > 0) {
        return '+' + formatNumber(val) + '만원'
      } else {
        return formatNumber(val) + '만원'
      }
    } else if (abs_val > 0) {
      if (val > 0) {
        return '+' + formatNumber(val) + '원'
      } else {
        return formatNumber(val) + '원'
      }      
    }
  }

  return val;
}

export function formatBigNumber(val) {
  if (val) {
    if (val > 1000000000000) {
      const value = (val / 1000000000000).toFixed(4);
      const tmp = value.split('.');
      if (tmp[1] === '0000') {
        return tmp[0] + '조'
      } else {
        return tmp[0] + '조 ' + parseInt(tmp[1]) + '억'
      }
    } else if (val > 100000000) {
      const value = (val / 100000000).toFixed(4);
      const tmp = value.split('.');
      if (tmp[1] === '0000') {
        return tmp[0] + '억'
      } else {
        return tmp[0] + '억 ' + parseInt(tmp[1]) + '만'
      }
    } else if (val > 10000) {
      const value = (val / 10000).toFixed(4);
      const tmp = value.split('.');
      if (tmp[1] === '0000') {
        return tmp[0] + '만'
      } else {
        return tmp[0] + '만 ' + parseInt(tmp[1])
      }
    } else {
      return formatNumber(val);
    }
  }
  return val;
}

export function to_date(yyyyMMdd) {
  var sYear = yyyyMMdd.substring(0,4);
  var sMonth = yyyyMMdd.substring(4,6);
  var sDate = yyyyMMdd.substring(6,8);

  return new Date(Number(sYear), Number(sMonth)-1, Number(sDate));
}

export function getChartUnit(val) {
  if (val > 5000000) {
    return 2000000
  } else if (val > 1000000) {
    return 1000000
  } else if (val > 500000) {
    return 200000
  } else if (val > 100000) {
    return 100000
  } else if (val > 50000) {
    return 20000
  } else if (val > 10000) {
    return 10000
  } else if (val > 5000) {
    return 2000
  } else if (val > 1000) {
    return 1000
  } else if (val > 500) {
    return 200
  } else if (val > 100) {
    return 100
  } else if (val > 50) {
    return 20
  } else if (val > 10) {
    return 10
  } else if (val > 5) {
    return 2
  } else {
    return 1
  }
}
